<template>
  <div class="box">

    <div class="system">
      <div class="returnn">
        <img src="../../../static/img2/fanhui2.png" alt="">
        <span @click="goBack" style="cursor:pointer;">返回</span>
      </div>
      <div class="setting">
        <img class="qian" src="../../../static/img2/11qian.png" alt="">
        <span class="medical_name">{{  course.name  }}</span>
        <div class="mapBox">
          <div id="mapCodeID" @click="enlarge" style="cursor:pointer;">
            <img v-show="defaultt" :src="imgurl+course.thum" class="imgitem" alt />
            <img v-if="showInfo.type == 'image'" :src="showInfo.path" class="imgitem" alt />
            <video v-else class="videogiazao" id="video01" controlslist="nodownload noremoteplayback" oncontextmenu="return false" :src="showInfo.path" autoplay="autoplay" alt=""></video>
          </div>

        </div>

        <div class="score"><span>5.0</span> <img src="../../../static/img2/pinff.png" alt=""><img src="../../../static/img2/pinff.png" alt=""><img src="../../../static/img2/pinff.png" alt=""><img src="../../../static/img2/pinff.png" alt=""><img src="../../../static/img2/pinff.png" alt=""></div>
        <img class="collect111" v-if="course.is_favorite == 1" src="../../../static/img2/shouc.png" @click="Collection_classes(course.id)" style="cursor:pointer;" alt="">
        <img class="collect111" v-else @click="Collection_classes(course.id)" style="cursor:pointer;" src="../../../static/img2/shoucwei.png" alt="">
        <div class="study">
          <div class="label">
            <span>标签内容：</span>
            <div class="tag_content">{{  course.category.parent_id === 2 ? '口腔类' : '临床类'  }}</div>
            <div class="tag_content2">{{  course.name  }}</div>
          </div>
          <div class="particulars">
            <span class="genre1">
              类型：{{  courseType[course.type]  }}
            </span>
            <span class="genre2">
              推荐完成时间 ：{{  course.times  }} 分钟
            </span>
            <span class="genre3">
              {{  course.user_count  }}人学习过此系统
            </span>
            <img src="../../../static/img2/initiate.png" class="initt" alt="">
            <img src="../../../static/img2/initiate.png" class="init" alt="">
            <img src="../../../static/img2/initiate.png" class="initxz" alt="">
            <div v-if="userInfo.school_id==100045" class="question" @click="questionon">答疑中心</div>
            <div class="initiate" @click="goLearn(course.url)" v-if="isDisabled" style="cursor:pointer;">
              开始学习
            </div>
            <div class="initiate" v-else style="cursor:pointer;">
              已过期
            </div>
            <div class="initiatee" @click="tips" style="cursor:pointer;">
              开始学习
            </div>
            <div class="initiateexz" @click="xiazai" style="cursor:pointer;">
              下载资源
            </div>
          </div>
        </div>
      </div>

    </div>
    <div class="select_image">
      <img class="rightx" v-show="arrows" @click="previous" src="../../../static/img2/fanyeright.png" alt="">

      <ul class="Img_ul">
        <li class="Img_li" v-for="(item, index) in imgUrlList" :key="index" :style="imgStyle" @click="selectItem(item, index)">
          <div class="zhoazhiaowu" v-show="index == i"></div>
          <span v-show="index == i" style="position:absolute;color:aliceblue;margin-top:10px;margin-left:5px;overflow: hidden;">{{item.title}}</span>
          <img :class="index === imgActiveIndex ? 'img_activeBorder' : ''" :src="item.path" alt="" v-if="item.type == 'image'">
          <video :class="index === imgActiveIndex ? 'img_activeBorder' : ''" :src="item.path" alt="" v-if="item.type == 'video'"></video>
        </li>
      </ul>

      <img class="leftx" v-show="arrows" src="../../../static/img2/fanyeleft.png" alt="" @click="following">
    </div>
    <div class="bottomxq">
      <div class="systematic">
        <div v-for="(item ,index) in course.details" :key="index" :class="{type : index== inde}"><span @click="tabChange1(index)" :class="{ secs: ys1 }">{{  item.title
                        }}</span>
        </div>
      </div>
      <div class="systematiclist">
        <div class="sytematic1" style="margin: 50px 70px;" v-for="(item ,index) in course.details" :key="index">
          <div v-show="tab == index" v-html="item.content"> </div>
        </div>
      </div>

    </div>
    <el-dialog title="提示" :visible.sync="dialogVisiblexzzy" width="800px" :before-close="handleClose">
      <!-- <div style="width: 500px;"> -->
      <el-table :data="course.resources" style="width: 100%">
        <el-table-column prop="path" label="日期" width="600" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="address" label="操作">
          <template slot-scope="scope">
            <el-tag @click="Download(scope.row.path)" style="cursor: pointer;">下载</el-tag>
          </template>
        </el-table-column>
      </el-table>
      <!-- </div> -->
    </el-dialog>
  </div>
</template>

<script>
import download from 'downloadjs'
//    document.getElementById("video").bind("contextmenu",function(){//取消右键事件
//         return false;
//     });
export default {
  name: 'CourseDetail',
  data() {
    return {
      resources: [], //下载数据
      dialogVisiblexzzy: false,
      i: null,
      isDisabled: true,
      tab: 0,
      courseType: ['在线训练', '模型', '智能设备'],
      course: {
        category: '',
      },
      inde: 0,
      xqlist: '',
      xqlist2: '',
      show: false,
      imgurl: 'http://www.univrlab.com/',
      FullScreen: false,
      imgUrlList: '',
      ys1: false,
      itemimage: '',

      activeName: 'first',
      value: 5.0,
      centerDialogVisible: false,
      iframeSrc: '',
      count: '',
      code: '',
      defaultt: true,
      arrows: false,
      titles: '',
      titles2: '',
      //isdisabled: false,
      schoolInfo: this.$store.getters.getUserInfo.school,
      userInfo: this.$store.getters.getUserInfo,
      imgchenck: '',
      imgActiveIndex: '', // 当前移动图片的索引值
      imgDistance: 0, // 移动的距离
      allDistance: 0, // 总移动距离

      showInfo: {
        type: '',
      },
    }
  },
  created() {
    this.getProbation()
    this.getsjCode()
    // console.log(this.$route.params.detailId)
  },
  computed: {
    imgStyle() {
      // console.log('this.imgDistance');
      // console.log(this.imgDistance);
      // console.log('this.imgDistance');

      return {
        transform: `translate3d(${this.imgDistance}px, 0, 0)`, // 计算移动的距离(x,y,z)
      }
    },
  },
  methods: {
    // 关闭下载
    handleClose() {
      this.dialogVisiblexzzy = false
    },
    xiazai() {
      this.dialogVisiblexzzy = true
      // this.course.resources.forEach((item) => {
      //   this.Download(item.path)
      // })
    },
    // 下载点击事件
    Download(row) {
      // console.log(row);
      // window.location.href = row
      // return
      let fileName = row.lastIndexOf('.') //取到文件名开始到最后一个点的长度
      let fileNameLength = row.length //取到文件名长度
      let fileFormat = row.substring(fileName + 1, fileNameLength) //截取文件的后缀名。
      // console.log(row)
      if (fileFormat == 'xls' || fileFormat == 'xlsx') {
        // window.location.href = row
        let link = document.createElement('a')
        link.style.display = 'none'
        link.href = row
        // link.setAttribute("download", '');
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link) // 下载完成移除元素
      } else {
        this.downloadImg(row)
      }
    },
    // 下载图片
    downloadImg(imgSrc, name) {
      console.log(imgSrc)
      // return
      const image = new Image()
      // 解决跨域 Canvas 污染问题
      image.setAttribute('crossOrigin', 'anonymous')
      image.onload = () => {
        const canvas = document.createElement('canvas')
        canvas.width = image.width
        canvas.height = image.height
        const context = canvas.getContext('2d')
        context.drawImage(image, 0, 0, image.width, image.height)
        canvas.toBlob((blob) => {
          const url = URL.createObjectURL(blob)
          const a = document.createElement('a')
          a.download = name || 'photo'
          a.href = url
          a.click()
          a.remove()
          URL.revokeObjectURL(url)
        })
      }
      image.src = imgSrc
    },
    questionon() {
      this.$router.push({ name: 'Questionon' })
    },
    questiononitem() {
      this.$router.push({ name: 'Questime' })
    },
    tabChange1(index) {
      let tabid = index
      this.tab = tabid
      this.inde = index
    },
    selectItem(item, index) {
      console.log(33333333)
      console.log(index)
      console.log(33333333)
      this.i = index
      this.showInfo = item
      this.imgActiveIndex = index
      this.defaultt = false
      if (this.imgActiveIndex <= 7) {
        this.imgDistance = 0

        // console.log(88888888);
        // var index = 0
        // const temp = window.setInterval(() => {
        //     if (index < 74) {
        //         this.imgDistance += 2 // 每次向右移动的距离
        //         index++
        //         return
        //     } else {
        //         window.clearInterval(temp)
        //     }
        // }, 10)
      }

      //  console.log(this.count )
    },
    tips() {
      alert('请通过带有独立显卡的电脑主机进行访问')
    },
    enlarge() {
      // let element = document.documentElement;//全屏放大
      let element = document.getElementById('mapCodeID') //需要全屏容器的id
      // 浏览器兼容
      if (this.FullScreen) {
        if (document.exitFullscreen) {
          document.exitFullscreen()
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen()
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen()
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen()
        }
      } else {
        if (element.requestFullscreen) {
          element.requestFullscreen()
        } else if (element.webkitRequestFullScreen) {
          element.webkitRequestFullScreen()
        } else if (element.mozRequestFullScreen) {
          element.mozRequestFullScreen()
        } else if (element.msRequestFullscreen) {
          element.msRequestFullscreen()
        }
      }
      this.FullScreen = !this.FullScreen
    },
    previous() {
      console.log(this.imgActiveIndex)
      if (this.imgActiveIndex > 0) {
        this.imgActiveIndex-- // 索引值-1
        this.i--
        this.imgUrlList.forEach((item, index) => {
          // 循环小图,通过判断索引值赋值给大图
          if (this.imgActiveIndex === index) {
            this.showInfo = item
            this.defaultt = false
          }
        })
      }
      if (this.imgActiveIndex >= 8) {
        var index = 0
        const temp = window.setInterval(() => {
          // 利用定时器实现图片左右移动的动画效果
          if (index < 95) {
            // 移动次数(33次)
            this.imgDistance += 2 // 每次向左移动的距离 (移动总距离为33*this.imgDistance)
            index++
            return
          } else {
            window.clearInterval(temp) // 移动完清除定时器
          }
        }, 10)
      }
      console.log(this.imgActiveIndex)

      if (this.imgActiveIndex == 7) {
        console.log(88888888)
        var index = 0
        const temp = window.setInterval(() => {
          if (index < 95) {
            this.imgDistance += 2 // 每次向右移动的距离
            index++
            return
          } else {
            window.clearInterval(temp)
          }
        }, 10)
      }
    },
    following() {
      // this.i=0
      if (this.imgActiveIndex === 0) {
        // var index = 0
        // const temp = window.setInterval(() => {
        //     if (index < 74) {
        //         this.imgDistance += 2 // 每次向右移动的距离
        //         index++
        //         return
        //     } else {
        //         window.clearInterval(temp)
        //     }
        // }, 10)
        this.imgDistance = 0
        this.imgUrlList.forEach((item, index) => {
          if (this.imgActiveIndex === index) {
            this.showInfo = item
            this.defaultt = false
          }
        })
        this.imgActiveIndex++
        this.i++
        return
      }
      if (this.imgActiveIndex === '') {
        this.imgActiveIndex = 0
        this.i = 0
        this.imgUrlList.forEach((item, index) => {
          if (this.imgActiveIndex === index) {
            this.showInfo = item
            this.defaultt = false
          }
        })
        // this.imgActiveIndex++

        return
      }

      if (
        this.imgActiveIndex < this.imgUrlList.length - 1 &&
        this.imgActiveIndex !== 0
      ) {
        this.imgActiveIndex++
        this.i++
        this.imgUrlList.forEach((item, index) => {
          if (this.imgActiveIndex === index) {
            this.showInfo = item
            this.defaultt = false
          }
        })
        if (this.imgActiveIndex >= 8) {
          this.allDistance = -190 * (this.imgActiveIndex - 7)
          console.log(this.allDistance)

          var index = 0
          const temp = window.setInterval(() => {
            if (index < 95) {
              this.imgDistance -= 2 // 每次向右移动的距离
              index++
              return
            } else {
              window.clearInterval(temp)
            }
          }, 1)
        }
      } else if (this.imgActiveIndex === this.imgUrlList.length - 1) {
        // 到达最后一张图片，再点击跳转回第一张
        this.imgActiveIndex = 0
        this.i = 0
        this.showInfo = this.imgUrlList[0]
        var index = 0
        const temp = window.setInterval(() => {
          // 利用定时器实现图片左右移动的动画效果

          if (index < Math.abs(this.allDistance / 2)) {
            // 取绝对值再除
            this.imgDistance += 2 // 每次向左移动的距离 (移动总距离为33*this.imgDistance)
            index++
            console.log(index)
            return
          } else {
            this.imgDistance = 0

            window.clearInterval(temp) // 移动完清除定时器
            return
          }
        }, 1)
      }
      if (this.imgActiveIndex === 0) {
        // var index = 0
        // const temp = window.setInterval(() => {
        //     if (index < 74) {
        //         this.imgDistance += 2 // 每次向右移动的距离
        //         index++
        //         return
        //     } else {
        //         window.clearInterval(temp)
        //     }
        // }, 10)

        const temp = window.setTimeout(() => {
          // 利用定时器实现图片左右移动的动画效果

          this.imgDistance = 0
        }, 400)

        this.imgUrlList.forEach((item, index) => {
          if (this.imgActiveIndex === index) {
            this.showInfo = item
            this.defaultt = false
          }
        })

        return
      }
    },
    color: function (id) {
      if (this.count === id) {
        return 'imgckeck'
      }
    },
    goBack() {
      this.$router.go(-1)
    },
    Collection_classes(id) {
      var id = id
      this.$http
        .ctionclass({ id: this.$route.params.detailId, learn_id: id })
        .then((res) => {
          if (res.code === 0) {
          }
          this.getCourse()
        })
    },
    getProbation() {
      if (this.userInfo.class.probation_status == 1) {
        this.$message({
          showClose: true,
          message:
            '该实验使用期将于' +
            this.userInfo.class.probation_date +
            '结束，请联系管理员延期。',
          type: 'warning',
          duration: 0,
        })
      }
      if (this.userInfo.class.probation_status == 2) {
        this.isDisabled = false
        this.$message({
          showClose: true,
          message:
            '该实验使用期已于' +
            this.userInfo.class.probation_date +
            '结束，请联系管理员续期。',
          type: 'error',
          duration: 0,
        })
      }
    },
    onCloseHandel() {
      this.$router.push({ name: 'practices' })
    },
    beforeCloseHandle() {
      this.$confirm('关闭窗口前请确认是否完成训练, 是否继续?', '提示', {
        confirmButtonText: '关闭窗口',
        cancelButtonText: '继续训练',
        type: 'warning',
      }).then(() => {
        this.onCloseHandel()
      })
    },
    afterEnter() {
      this.show = false
    },

    // 获取课程详情
    getCourse() {
      var user_id = this.$store.getters.getUserInfo.id
      this.$http
        .courseAllList({ id: this.$route.params.detailId, user_id: user_id })
        .then((res) => {
          if (res.code !== 0) {
            this.course = res.data.learn[0]
            console.log(this.course)
            let xqlist = res.data.learn[0].details[0].content
            this.xqlist2 = res.data.learn[0].details[1].content
            this.titles = res.data.learn[0].details[0].title
            this.titles2 = res.data.learn[0].details[1].title
            this.xqlist = xqlist
            let imgUrlList = res.data.learn[0].files
            this.imgUrlList = imgUrlList
            console.log(imgUrlList)
            if (this.imgUrlList != '') {
              this.arrows = true
            }
            // this.showInfo = this.course.files[0]
          } else {
            this.$message.error(res.message)
          }
        })
    },
    //获取随机码
    getsjCode() {
      this.$http.getsjCode().then((res) => {
        if (res.code == 200) {
          this.code = res.data
        } else {
          this.$message.error(res.message)
        }
      })
    },
    goLearn() {
      this.$http.ctionstart('learn_id=' + this.$route.params.detailId).then((res) => {
          if (res.code == 200) {
            this.$http.getlearnurl({learn_id: this.$route.params.detailId,user_id: this.$store.getters.getUserInfo.id}).then((res) => {
                if (res.code==200) {
                  if (this.$cookies.get('token')) {
                    if (this.$store.getters.getUserInfo.type == 4) {
                      this.$message.warning('您当前申请的班级信息正在审核中,此功能无法使用,请联系老师审核。')
                      return false
                    }
                    if (this.$store.getters.getUserInfo.type == 5) {
                      this.$message.warning('您当前申请的班级信息已被驳回，此功能无法使用,请至个人中心修改后重新提交。')
                      return false
                    }
                    var baseurl = this.GLOBAL.BASE_URL
                    window.location.href =res.data +'?user_id=' +this.$store.getters.getUserInfo.id +'+' +baseurl +'+' +this.code +'+' +this.$route.params.detailId+'+' +0
                  } else {
                    this.$router.push({ name: 'Login' })
                  }
                } else {this.$message('暂未开放')}
              })
          } else {
            this.$message.error(res.message)
          }
        })
    },
  },
  mounted() {
    this.getCourse()
  },
}
</script>


<style lang="less" >
@import '../../../static/fonts/stylemain/style.less';
@media screen and (max-width: 768px) {
  .videogiazao {
    width: 661px;
    height: 372px;
    position: absolute;
    top: 75px;
    left: 45px;
  }
  .box {
    width: 100%;
    height: 100%;
    overflow: hidden;
    background-color: #212129;
    .imgckeck {
      border: 2px solid #07f4ff;
      background-color: rgba(25, 24, 24, 0.9);
      z-index: 10000;
    }

    .sousuo {
      height: 78px;
      width: 100%;
      position: relative;

      input {
        width: 400px;
        height: 35px;
        border: 0;
        border-radius: 25px;
        position: absolute;
        top: 20px;
        left: 708px;
        outline: none;
      }

      button {
        width: 115px;
        height: 35px;
        background-color: #1eb9ef;
        border: 0;
        border-radius: 25px;
        color: #fff;
        position: absolute;
        top: 21px;
        left: 1060px;
        font-size: 16px;
        padding-left: 30px;
      }

      img {
        position: absolute;
        top: 30px;
        left: 1085px;
        z-index: 1000;
      }
    }

    .system {
      width: 100%;
      height: 305rem;

      .returnn {
        width: 100%;
        height: 75px;
        margin: auto;
        position: relative;

        img {
          position: absolute;
          top: 8rem;
          left: 6rem;
        }

        span {
          position: absolute;
          top: 6.8rem;
          left: 12rem;
          font-size: 16px;
          color: #1eb9ee;
        }
      }

      .setting {
        width: 100%;
        //  height: 100%;
        background-color: #282931;
        margin: auto;
        position: relative;

        .qian {
          position: absolute;
          top: 31px;
          left: 46px;
        }
      }

      .medical_name {
        font-size: 14px;
        color: #fff;
        position: absolute;
        top: 8.5rem;
        left: 64px;
        z-index: 10000;
      }

      .score {
        width: 176px;
        height: 25px;
        position: absolute;
        top: 105rem;
        left: 10rem;

        span {
          font-size: 24px;
          color: #ffb628;
        }

        img {
          padding-left: 5px;
        }
      }

      .collect111 {
        position: absolute;
        top: 105rem;
        right: 7rem;
      }

      .study {
        width: 115rem;
        height: 90rem;
        background-color: #36373f;
        position: absolute;
        top: 120rem;
        right: 3rem;
        letter-spacing: 1px;
        .label {
          width: 110rem;
          height: 117px;
          margin: auto;
          border-bottom: 1px solid #5a5b66;

          span {
            position: absolute;
            top: 36px;
            left: 45px;
            font-size: 12px;
            color: #fff;
          }

          .tag_content {
            width: 74px;
            height: 27px;
            background-color: #3c4853;
            font-size: 12px;
            color: #6edbff;
            line-height: 27px;
            text-align: center;
            border-radius: 25px;
            position: absolute;
            top: 66px;
            left: 2rem;
          }

          .tag_content2 {
            //  width: 109px;
            max-width: 220px;
            height: 27px;
            background-color: #3c4853;
            font-size: 12px;
            color: #6edbff;
            line-height: 27px;
            text-align: center;
            border-radius: 25px;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            position: absolute;
            top: 66px;
            left: 28rem;
            padding: 0 18px 0 18px;
          }
        }

        .particulars {
          width: 383px;
          height: 140px;
          margin: auto;
          position: relative;

          .genre1 {
            position: absolute;
            top: 29px;
            left: 14px;
            color: #ffffff;
            font-size: 12px;
          }

          .genre2 {
            position: absolute;
            top: 63px;
            left: 14px;
            color: #ffffff;
            font-size: 12px;
          }

          .genre3 {
            position: absolute;
            top: 97px;
            left: 14px;
            color: #ffffff;
            font-size: 12px;
          }

          .init {
            display: none;
            position: absolute;
            top: 50rem;
            left: 35rem;
          }
          .initxz {
            display: none;
          }
          .initt {
            position: absolute;
            top: 50rem;
            left: 35rem;
          }

          .initiate {
            display: none;
            position: absolute;
            top: 52.5rem;
            left: 44.5rem;
            font-size: 18px;
            color: #fff;
          }
          .initiateexz {
            display: none;
          }
          .initiatee {
            position: absolute;
            top: 52.5rem;
            left: 45rem;
            font-size: 18px;
            color: #fff;
          }
        }
      }
    }

    .select_image {
      width: 100%;
      height: 100%;
      display: flex;
      flex-wrap: wrap;
      position: relative;
      top: -50rem;

      .rightx {
        display: none;
      }

      .leftx {
        display: none;
      }

      .Img_ul {
        height: 100%;
        width: 98%;
      }

      .Img_li {
        width: 41rem;
        height: 21rem;
        float: left;
        margin: 0 5rem 5rem 12rem;
        cursor: pointer;

        img {
          width: 40rem;
          height: 20rem;
        }
      }

      .img_activeBorder {
        border: 2px solid #07f4ff;
      }
    }

    .bottomxq {
      width: 90%;
      margin: auto;
      background-color: #212229;
      border: 0;
      position: relative;
      top: -40rem;
      color: rgb(252, 250, 250);

      //   border-top: 1px solid #6edbff;
      .sytematic1 {
        width: 100rem;
      }

      .sytematic2 {
        width: 100rem;
      }

      .systematic {
        height: 44px;
        width: 100%;
        background-color: #282931;

        .type {
          border: 1px solid #6edbff;
          background-color: #212229;
          z-index: 1000;
          color: #6edbff;
          border-bottom: 1px solid #212229;
          cursor: pointer;
        }

        .secs {
          height: 20px;
          border-bottom: 1px solid #6edbff;
          padding-bottom: 10px;
        }

        div {
          width: 106px;
          height: 100%;
          float: left;
          line-height: 44px;
          text-align: center;
          font-size: 16px;
          color: #64656a;
          margin-top: -1px;
          cursor: pointer;
        }
      }

      .systematiclist {
        width: 100%;
        border: 1px solid #6edbff;
      }
    }

    .mapBox {
      position: relative;
    }

    #mapCodeID {
      width: 100rem;
      height: 80rem;
      position: absolute;
      top: 75px;
      left: 10rem;
    }

    #mapCodeID .imgitem {
      width: 100%;
      height: 100%;
    }

    .mapBox .iconBox {
      cursor: pointer;
      position: absolute;
      width: 30px;
      height: 30px;
      top: 90px;
      left: 650px;
    }

    .mapBox .iconBox img {
      position: absolute;
      top: 5px;
      left: 5px;
    }
  }
}

@media screen and (min-width: 768px) {
  .box {
    width: 100%;
    height: 100%;
    overflow: hidden;
    background-color: @bg3;

    .imgckeck {
      border: 2px solid #07f4ff;
      background-color: rgba(25, 24, 24, 0.9);
      z-index: 10000;
    }

    .sousuo {
      height: 78px;
      width: 100%;
      position: relative;

      input {
        width: 400px;
        height: 35px;
        border: 0;
        border-radius: 25px;
        position: absolute;
        top: 20px;
        left: 708px;
        outline: none;
      }

      button {
        width: 115px;
        height: 35px;
        background-color: #1eb9ef;
        border: 0;
        border-radius: 25px;
        color: #fff;
        position: absolute;
        top: 21px;
        left: 1060px;
        font-size: 16px;
        padding-left: 30px;
      }

      img {
        position: absolute;
        top: 30px;
        left: 1085px;
        z-index: 1000;
      }
    }

    .system {
      width: 100%;
      height: 715px;
      background-color: @bg1;

      .returnn {
        width: 1219px;
        height: 75px;
        margin: auto;
        position: relative;

        img {
          position: absolute;
          top: 30px;
          left: 0;
        }

        span {
          position: absolute;
          top: 25px;
          left: 30px;
          font-size: 16px;
          color: #1eb9ee;
        }
      }

      .setting {
        width: 1219px;
        height: 482px;
        background-color: @bg2;
        margin: auto;
        position: relative;

        .qian {
          position: absolute;
          top: 31px;
          left: 46px;
        }
      }

      .medical_name {
        font-size: 24px;
        color: @writing;
        position: absolute;
        top: 23px;
        left: 64px;
      }

      .score {
        width: 176px;
        height: 25px;
        position: absolute;
        top: 79px;
        left: 741px;

        span {
          font-size: 24px;
          color: #ffb628;
        }

        img {
          padding-left: 5px;
        }
      }

      .collect111 {
        position: absolute;
        top: 75px;
        right: 76px;
      }

      .study {
        width: 424px;
        height: 294px;
        background-color: @bg3;
        position: absolute;
        top: 134px;
        right: 56px;

        .label {
          width: 383px;
          height: 117px;
          margin: auto;
          border-bottom: 1px solid #5a5b66;

          span {
            position: absolute;
            top: 36px;
            left: 45px;
            font-size: 12px;
            color: @writing;
          }

          .tag_content {
            width: 74px;
            height: 27px;
            background-color: #3c4853;
            font-size: 12px;
            color: #6edbff;
            line-height: 27px;
            text-align: center;
            border-radius: 25px;
            position: absolute;
            top: 66px;
            left: 45px;
          }

          .tag_content2 {
            //  width: 109px;
            max-width: 220px;
            height: 27px;
            background-color: #3c4853;
            font-size: 12px;
            color: #6edbff;
            line-height: 27px;
            text-align: center;
            border-radius: 25px;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            position: absolute;
            top: 66px;
            left: 133px;
            padding: 0 18px 0 18px;
          }
        }

        .particulars {
          width: 383px;
          height: 140px;
          margin: auto;
          position: relative;

          .genre1 {
            position: absolute;
            top: 29px;
            left: 14px;
            color: @writing;
            font-size: 12px;
          }

          .genre2 {
            position: absolute;
            top: 63px;
            left: 14px;
            color: @writing;
            font-size: 12px;
          }

          .genre3 {
            position: absolute;
            top: 97px;
            left: 14px;
            color: @writing;
            font-size: 12px;
          }

          .init {
            position: absolute;
            top: 154px;
            left: 40px;
          }
          .initxz {
            position: absolute;
            top: 154px;
            left: 210px;
          }
          .initt {
            display: none;
            position: absolute;
            top: 154px;
            left: 121px;
          }

          .initiate {
            position: absolute;
            top: 162px;
            left: 75px;
            font-size: 18px;
            color: #fff;
          }
          .question {
            position: absolute;
            top: 92px;
            left: 265px;
            font-size: 18px;
            cursor: pointer;
            color: #fff;
          }
          .question1 {
            position: absolute;
            top: 50px;
            left: 265px;
            font-size: 18px;
            cursor: pointer;
            color: #fff;
          }
          .initiateexz {
            position: absolute;
            top: 162px;
            left: 242px;
            font-size: 18px;
            color: #fff;
          }
          .initiatee {
            display: none;
            position: absolute;
            top: 162px;
            left: 155px;
            font-size: 18px;
            color: #fff;
          }
        }
      }
    }

    .select_image {
      width: 1219px;
      height: 158px;
      margin: auto;
      position: relative;
      top: -150px;
      left: 0;

      .rightx {
        position: absolute;
        top: 30px;
        left: 0;
      }

      .leftx {
        position: absolute;
        top: 30px;
        right: 0;
      }

      .Img_ul {
        position: relative;
        display: flex;
        left: 45px;
        width: 1155px;
        height: 80px;
        top: 30px;
        overflow: hidden;
        list-style: none;
      }

      .Img_li {
        float: left;
        margin: 0 8px;
        cursor: pointer;

        img {
          width: 132px;
          height: 75px;
        }

        video {
          width: 132px;
          height: 75px;
        }
        .zhoazhiaowu {
          width: 96%;
          height: 90%;
          top: 3px;
          position: absolute;
          left: 3px;
          background: rgba(0, 0, 0, 0.5);
        }
      }

      .img_activeBorder {
        border: 2px solid #07f4ff;
      }
    }

    .bottomxq {
      width: 1219px;
      margin: auto;
      background-color: #212229;
      border: 0;
      color: #fff;
      position: relative;
      top: -100px;

      //   border-top: 1px solid #6edbff;
      .sytematic1 {
        /*width: 1100px;*/
      }

      .systematic {
        width: 100%;
        padding-right: 2px;
        height: 44px;
        background-color: @bg2;
        position: relative;

        .type {
          border: 1px solid @inpborder;
          background-color: @bg3;
          z-index: 1000;
          color: #6edbff;
          border-bottom: 1px solid @bg3;
          cursor: pointer;
        }

        .secs {
          height: 20px;
          border-bottom: 1px solid @inpborder;
          padding-bottom: 10px;
        }

        div {
          width: 106px;
          height: 100%;
          float: left;
          line-height: 44px;
          text-align: center;
          font-size: 16px;
          color: #64656a;
          margin-top: -1px;
          cursor: pointer;
        }
      }

      .systematiclist {
        width: 100%;
        border: 1px solid @inpborder;
        background-color: @bg3;
        color: @writing;
      }
    }

    .mapBox {
      position: relative;
    }

    #mapCodeID {
      width: 661px;
      height: 372px;
      position: absolute;
      top: 75px;
      left: 45px;
    }

    #mapCodeID .imgitem {
      width: 100%;
      height: 100%;
    }
    #mapCodeID .videogiazao {
      width: 100%;
      height: 100%;
    }

    .mapBox .iconBox {
      cursor: pointer;
      position: absolute;
      width: 30px;
      height: 30px;
      top: 90px;
      left: 650px;
    }

    .mapBox .iconBox img {
      position: absolute;
      top: 5px;
      left: 5px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Course/CourseDetail.vue